// extracted by mini-css-extract-plugin
export default {"pageWrapper":"WelcomeScreen_pageWrapper__OH8ob","mainContainer":"WelcomeScreen_mainContainer__coYpt","loadingContainer":"WelcomeScreen_loadingContainer__ziMIa"};